import React, { useState } from "react";
import PropTypes from "prop-types";
import style from "./burger-menu-gender-menu.css";
import SwipeableViews from "react-swipeable-views";
import BurgerMenuItem from "../burger-menu-item/burger-menu-item";
import BurgerMenuSmallItem from "../burger-menu-small-item/burger-menu-small-item";

function BurgerMenuGenderedMenu({
    menuData,
    selectedGender,
    currentCountry,
    currentCurrency,
    showCountryPicker,
    onCategoryClick,
    onCountrySelectorClick,
    updateGenderState
}) {
    const MEN_PAGE_INDEX = 1;
    const WOMEN_PAGE_INDEX = 0;

    const [genderMenuIndex, setGenderMenuIndex] = useState(getGenderIndex());

    function getGenderIndex() {
        return selectedGender === "Men" ? 1 : 0;
    }

    function onGenderClick(gender) {
        if (gender === "Men") {
            setGenderMenuIndex(MEN_PAGE_INDEX);
        } else {
            setGenderMenuIndex(WOMEN_PAGE_INDEX);
        }
        updateGenderState(gender);
    }

    function renderGenderSelector() {
        if (selectedGender) {
            return (
                <div className={style.genderSelector}>
                    <div
                        className={
                            selectedGender === "Women"
                                ? style.genderActive
                                : style.genderOption
                        }
                        onClick={() => onGenderClick("Women")}
                    >
                        Women
                    </div>
                    <div
                        className={
                            selectedGender === "Men"
                                ? style.genderActive
                                : style.genderOption
                        }
                        onClick={() => onGenderClick("Men")}
                    >
                        Men
                    </div>
                </div>
            );
        }
    }

    let genderMenus = menuData.map((genderedMenu, index) => {
        return (
            <ul key={index} id="genderedMenuLinks">
                {genderedMenu.by_category.categories.map((category, index) => {
                    return (
                        <BurgerMenuItem
                            key={index}
                            renderText={category.name}
                            renderChevron={true}
                            onClickEvent={() => onCategoryClick(category.name)}
                        />
                    );
                })}
                {genderedMenu.by_brand.categories.map((brand, index) => {
                    return (
                        <BurgerMenuItem
                            key={index}
                            renderText={brand.name}
                            href={brand.single_link}
                        />
                    );
                })}
                <BurgerMenuSmallItem
                    renderText={
                        "Country: " + currentCountry + " - " + currentCurrency
                    }
                    renderChevron={showCountryPicker}
                    onClickEvent={() => onCountrySelectorClick()}
                />
                <BurgerMenuSmallItem
                    renderText={"Help center"}
                    href={"https://help.lyst.com/hc/en-gb"}
                />
                <BurgerMenuSmallItem
                    renderText={"Contact us"}
                    href={"/help/contact-us/"}
                />
                <BurgerMenuSmallItem
                    renderText={"About us"}
                    href={"/about/"}
                />
                <BurgerMenuSmallItem
                    renderText={"Careers"}
                    href={"/careers/"}
                />
            </ul>
        );
    });

    return (
        <div className={style.genderedMenu}>
            {renderGenderSelector()}
            <SwipeableViews disabled index={genderMenuIndex}>
                {genderMenus}
            </SwipeableViews>
        </div>
    );
}

export default BurgerMenuGenderedMenu;

BurgerMenuGenderedMenu.propTypes = {
    menuData: PropTypes.array,
    selectedGender: PropTypes.string,
    currentCountry: PropTypes.string,
    currentCurrency: PropTypes.string,
    showCountryPicker: PropTypes.bool,
    onCategoryClick: PropTypes.func.isRequired,
    onCountrySelectorClick: PropTypes.func.isRequired,
    updateGenderState: PropTypes.func.isRequired
};

BurgerMenuGenderedMenu.defaultProps = {
    menuData: [],
    selectedGender: "",
    currentCountry: "",
    currentCurrency: "",
    showCountryPicker: false
};
